import Color from "@tiptap/extension-color";
import FontFamily from "@tiptap/extension-font-family";
import Highlight from "@tiptap/extension-highlight";
import Image from "@tiptap/extension-image";
import Mention from "@tiptap/extension-mention";
import { TableKit } from "@tiptap/extension-table";
import TaskItem from "@tiptap/extension-task-item";
import TaskList from "@tiptap/extension-task-list";
import TextAlign from "@tiptap/extension-text-align";
import { FontSize, TextStyle } from "@tiptap/extension-text-style";
import Youtube from "@tiptap/extension-youtube";
import { StarterKit } from "@tiptap/starter-kit";
import { CharacterCount, Placeholder } from "@tiptap/extensions";

export function createEditorExtensions({ placeholder = "", characterLimit = 10000 }) {
  return [
    StarterKit.configure({
      link: {
        openOnClick: false,
        autolink: true,
        defaultProtocol: "https",
      },
    }),
    Placeholder.configure({
      placeholder,
      emptyEditorClass: "is-editor-empty",
    }),
    CharacterCount.configure({
      limit: characterLimit,
    }),
    TextStyle.configure({
      mergeNestedSpanStyles: true,
    }),
    Color,
    Highlight.configure({ multicolor: true }),
    FontFamily,
    FontSize,
    TextAlign.configure({
      types: ["heading", "paragraph"],
    }),
    TaskList,
    TaskItem.configure({
      nested: true,
    }),
    TableKit.configure({
      table: { resizable: true },
    }),
    Image.configure({
      inline: false,
      allowBase64: true,
    }),
    Youtube.configure({
      controls: true,
      nocookie: true,
    }),
    Mention.configure({
      HTMLAttributes: {
        class: "mention-chip",
      },
      suggestion: {
        char: "@",
        items: ({ query }) => {
          const mentionPool = ["admin", "finance", "security", "ops", "support", "qa"];
          return mentionPool
            .filter((item) => item.toLowerCase().includes(query.toLowerCase()))
            .slice(0, 5)
            .map((id) => ({ id, label: id }));
        },
      },
    }),
  ];
}
